/* This file is in core bundle because it's used by tutorial. */
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const ColorUtil = require("../util/ColorUtil");
const AssetsUtil = require("../util/AssetsUtil");
const QuadUtil = require("../util/QuadUtil");
const Quad = require("./Quad");
const Z = require("../../../shared/ZIndex");
const Stars = require("./Stars");

const styles = require("./styles/BarLegend.css");

module.exports = createReactClass({
	displayName: "BarLegend",

	propTypes: {
		gradeNumber: PT.number.isRequired,
	},

	getStarImages: function(numStars) {
		return _.range(numStars).map(i => (
			<img
				key={"star" + i}
				className={styles.star}
				src={AssetsUtil.getProfileIcon("star", true)}
			/>
		));
	},

	render: function() {
		const colors = ColorUtil.getThemeColors("grade" + this.props.gradeNumber)
			.profile;

		const els = colors.map((color, i) => {
			const bgStyle = {
				backgroundColor: color,
			};
			let bg = <div className={styles.bg} style={bgStyle} />;
			// First and last element are deformed.
			const quadSet = QuadUtil.getBarLegendSet();
			if (i === 0) {
				bg = (
					<div className={styles.bg}>
						<Quad quad={quadSet.first} backgroundColor={color} />
					</div>
				);
			} else if (i === 3) {
				bg = (
					<div className={styles.bg}>
						<Quad quad={quadSet.last} backgroundColor={color} />
					</div>
				);
			}
			const entryStyle = {
				// Deformed elements on either end go under middle ones.
				zIndex: i === 0 || i === 3 ? Z.profileLegendEnd : Z.profileLegendMiddle,
			};

			// const stars = this.getStarImages(colors.length - i - 1);
			const stars = (
				<Stars
					numStars={colors.length - i - 1}
					starClass={styles.star}
					earnedStarType={"trainer"}
					mainClass={styles.starOuter}
				/>
			);

			return (
				<div className={styles.entry} key={i} style={entryStyle}>
					{bg}
					{stars}
				</div>
			);
		});

		return <div className={styles.main}>{els}</div>;
	},
});
